import React from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Msg #986 — Password reset landing page. Reads ?token=… from the URL, lets
// the user pick a new password, then POSTs to /api/auth/password_reset_confirm.
const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [pw1, setPw1] = React.useState('');
  const [pw2, setPw2] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [ok, setOk] = React.useState('');
  const [err, setErr] = React.useState('');

  const submit = async () => {
    setErr(''); setOk('');
    if (!token) { setErr('Missing reset token. Use the link from the email.'); return; }
    if (pw1.length < 4) { setErr('Password is too short (minimum 4 characters).'); return; }
    if (pw1 !== pw2) { setErr('Passwords do not match.'); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/password_reset_confirm`, { token, new_password: pw1 });
      setOk('Password updated. Redirecting to login…');
      setTimeout(() => navigate('/login'), 1400);
    } catch (e) {
      const d = e && e.response && e.response.data && e.response.data.detail;
      setErr(d || 'Reset failed. Request a fresh link.');
    } finally { setBusy(false); }
  };

  return (
    <div className="keep-bg min-h-screen">
      <div className="keep-header-bar w-full" />
      <div className="max-w-[640px] mx-auto px-4 pt-8">
        <div className="keep-frame">
          <div className="p-8">
            <h1 className="keep-title">Reset Password</h1>
            <div className="text-center text-[13px] mt-4">
              Enter your new Mandala password below.
            </div>
            <div className="flex justify-center mt-6">
              <div className="keep-login-box w-[520px]" data-testid="reset-password-box">
                <table className="mx-auto" cellPadding="4">
                  <tbody>
                    <tr>
                      <td className="text-right">New password :</td>
                      <td>
                        <input
                          data-testid="reset-password-new"
                          type="password" className="keep-input"
                          value={pw1}
                          onChange={(e) => setPw1(e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right">Confirm :</td>
                      <td>
                        <input
                          data-testid="reset-password-confirm"
                          type="password" className="keep-input"
                          value={pw2}
                          onChange={(e) => setPw2(e.target.value)}
                          onKeyDown={(e) => e.key === 'Enter' && submit()}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                {err && (
                  <div data-testid="reset-password-error"
                       className="text-center text-[12px] text-red-700 mt-3">{err}</div>
                )}
                {ok && (
                  <div data-testid="reset-password-ok"
                       className="text-center text-[12px] text-green-800 mt-3">{ok}</div>
                )}
                <div className="text-center mt-5">
                  <button
                    data-testid="reset-password-submit"
                    className="keep-btn"
                    onClick={submit}
                    disabled={busy}
                    style={{ opacity: busy ? 0.7 : 1, cursor: busy ? 'wait' : 'pointer' }}
                  >
                    {busy ? 'Saving…' : 'SET PASSWORD'}
                  </button>
                </div>
                <div className="text-center mt-3 text-[12px]">
                  <span
                    className="keep-link"
                    onClick={() => navigate('/login')}
                    data-testid="reset-password-back-login"
                    style={{ cursor: 'pointer' }}
                  >Back to Login</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
